/**
 * Shared switch table styles used by both SwitchSection (one-time) and SwitchPlansTrade (plans).
 *
 * One-time switch extends this with switchQuantityCellStyles for the quantity column.
 */
import { makeStyles } from "@material-ui/core";

import {
  baseTableCellStyles,
  baseTableFooterStyles,
  baseTableRowStyles,
  switchPositionCellStyles,
  switchAmountCellStyles,
  switchPercentageCellStyles,
  switchHighlightedRowStyles,
  tableContainerStyles,
} from "./sharedTableStyles";

const switchTableBaseStyles = () => ({
  tableContainer: tableContainerStyles,
  tableCell: {
    ...baseTableCellStyles,
    '&:nth-child(1)': switchPositionCellStyles,
    '&.switch-amount-cell': switchAmountCellStyles,
    '&.switch-percentage-cell': {
      ...switchPercentageCellStyles,
      width: 120
    },
  },
  tableFooter: {
    ...baseTableFooterStyles,
  },
  tableRow: {
    ...baseTableRowStyles,
    ...switchHighlightedRowStyles,
  },
});

export const useSwitchTableBaseStyles = makeStyles(switchTableBaseStyles);

export default switchTableBaseStyles;
